/**
 * SEO Utilities
 * Provides structured data (JSON-LD) and meta tag generation
 * Target Markets: Nepal, India, Global Hindu/Nepali Diaspora
 * Optimized for: Best Astrology, Remedies, Spiritual Healing, Gemstones, Hindu Culture
 */

export const siteConfig = {
  name: 'Swastishanti',
  alternativeName: 'Swasti Shanti - Best Vedic Astrology India Nepal',
  url: 'https://swastishanti.com',
  description: 'India & Nepal\'s #1 Vedic Astrology Platform with Highest Client Success Rate. Expert Hindu Astrology, Jyotish Consultation, Spiritual Healing, Gemstone Recommendations, Astrological Remedies for all life problems. Serving Hindu community worldwide. 98% Client Satisfaction.',
  ogImage: 'https://swastishanti.com/og-image.jpg',
  twitterHandle: '@swastishanti',
  locale: 'en_US',
  type: 'website' as const,
  
  // Target regions
  targetRegions: ['Nepal', 'India', 'USA', 'UK', 'Australia', 'Canada', 'UAE', 'Qatar', 'Malaysia', 'Singapore'],
  
  // USP - Unique Selling Points for SEO
  usp: {
    clientSuccessRate: '98%',
    totalClients: '15,000+',
    yearsExperience: '15+',
    expertAstrologers: '25+',
    countriesServed: '50+',
  },
  
  // Primary target keywords for SEO - Comprehensive list targeting top rankings
  keywords: [
    // ==========================================
    // PRIORITY 1: Best Astrology India & Nepal Keywords
    // ==========================================
    'best astrology in india',
    'best astrologer in india',
    'best astrologer india',
    'top astrologer india',
    'famous astrologer india',
    'best jyotish in india',
    'best vedic astrologer india',
    'best astrology in nepal',
    'best astrologer in nepal',
    'best astrologer nepal',
    'top astrologer nepal',
    'famous astrologer nepal',
    'no 1 astrologer',
    'best online astrologer',
    'best astrology consultation',
    'india best astrology',
    'nepal best astrology',
    
    // ==========================================
    // PRIORITY 2: Hindu Astrology & Culture Keywords
    // ==========================================
    'hindu astrology',
    'hindu jyotish',
    'hindu horoscope',
    'hindu astrologer',
    'hindu panchang',
    'hindu calendar',
    'hindu festivals',
    'hindu puja',
    'hindu rituals',
    'hindu spiritual guidance',
    'hindu remedies',
    'sanatan dharma astrology',
    'vedic hindu astrology',
    'hindu kundli',
    'hindu marriage astrology',
    'hindu birth chart',
    
    // ==========================================
    // PRIORITY 3: Indian Culture & Regional Keywords
    // ==========================================
    'indian astrology',
    'indian astrologer',
    'indian jyotish',
    'indian horoscope',
    'bharatiya jyotish',
    'desi astrology',
    'indian vedic astrology',
    'indian spiritual healer',
    'indian pandit',
    'indian puja services',
    'astrologer delhi',
    'astrologer mumbai',
    'astrologer bangalore',
    'astrologer kolkata',
    'astrologer chennai',
    'astrologer hyderabad',
    'astrologer pune',
    'astrologer ahmedabad',
    'astrologer jaipur',
    'online indian astrologer',
    
    // ==========================================
    // PRIORITY 4: Nepali Culture Keywords
    // ==========================================
    'nepali astrology',
    'nepali jyotish',
    'nepali pandit',
    'nepali puja',
    'nepali calendar',
    'nepali panchang',
    'bikram sambat',
    'nepali festivals',
    'nepali horoscope',
    'nepali kundli',
    'nepali spiritual healer',
    'astrologer kathmandu',
    
    // ==========================================
    // PRIORITY 5: Global Hindu Diaspora Keywords
    // ==========================================
    'hindu astrologer usa',
    'indian astrologer usa',
    'vedic astrology usa',
    'hindu astrologer uk',
    'indian astrologer uk',
    'hindu astrologer australia',
    'indian astrologer australia',
    'hindu astrologer canada',
    'indian astrologer canada',
    'nri astrology services',
    'overseas indian astrology',
    'hindu astrologer dubai',
    'indian astrologer uae',
    'hindu astrologer singapore',
    'hindu astrologer malaysia',
    'online astrology worldwide',
    'international vedic astrologer',
    
    // ==========================================
    // PRIORITY 6: Remedies Keywords (All Markets)
    // ==========================================
    'astrological remedies',
    'astrology remedies',
    'vedic remedies',
    'jyotish remedies',
    'hindu remedies',
    'remedies for planets',
    'planetary remedies',
    'graha shanti remedies',
    'graha dosh remedies',
    'remedies for bad luck',
    'remedies for marriage',
    'remedies for career',
    'remedies for health',
    'remedies for wealth',
    'remedies for success',
    'shani remedies',
    'shani sade sati remedies',
    'rahu remedies',
    'ketu remedies',
    'mangal dosh remedies',
    'manglik remedies',
    'kaal sarp dosh remedies',
    'pitra dosh remedies',
    'nazar dosh remedies',
    'vastu remedies',
    'tantric remedies',
    'mantra remedies',
    'yantra remedies',
    'totke for problems',
    'upay for success',
    
    // ==========================================
    // PRIORITY 7: Spiritual & Healing Keywords
    // ==========================================
    'spiritual healing',
    'spiritual healing india',
    'spiritual healing nepal',
    'spiritual guidance',
    'spiritual consultation',
    'spiritual services',
    'spiritual wellness',
    'spiritual therapy',
    'energy healing',
    'chakra healing',
    'chakra balancing',
    'aura healing',
    'aura cleansing',
    'pranic healing',
    'reiki healing',
    'divine healing',
    'holistic healing',
    'vedic healing',
    'hindu spiritual healing',
    'kundalini awakening',
    'meditation guidance',
    'spiritual counseling',
    'soul healing',
    'karmic healing',
    'past life healing',
    'negative energy removal',
    'black magic removal',
    'evil eye protection',
    'nazar utarna',
    
    // ==========================================
    // PRIORITY 8: Gemstone Keywords
    // ==========================================
    'gemstone',
    'gemstone astrology',
    'astrological gemstones',
    'gemstone recommendation',
    'gemstone for rashi',
    'ratna recommendation',
    'vedic gemstones',
    'jyotish gemstones',
    'lucky gemstone',
    'birthstone astrology',
    'navratna gemstones',
    'ruby gemstone',
    'manik ratna',
    'emerald gemstone',
    'panna ratna',
    'blue sapphire',
    'neelam ratna',
    'yellow sapphire',
    'pukhraj ratna',
    'pearl gemstone',
    'moti ratna',
    'red coral',
    'moonga ratna',
    'hessonite garnet',
    'gomed ratna',
    'cats eye',
    'lahsuniya ratna',
    'diamond astrology',
    'heera ratna',
    'gemstone shop india',
    'buy gemstone online',
    'certified gemstones',
    
    // ==========================================
    // PRIORITY 9: Vedic Astrology & Jyotish Keywords
    // ==========================================
    'vedic astrology',
    'vedic astrologer',
    'vedic jyotish',
    'jyotish shastra',
    'jyotish vidya',
    'vedic horoscope',
    'vedic birth chart',
    'vedic kundli',
    'janam kundli',
    'janam patri',
    'kundali analysis',
    'kundali matching',
    'gun milan',
    'kundli milan',
    'horoscope matching',
    'marriage compatibility',
    'love compatibility',
    'rashi analysis',
    'nakshatra analysis',
    'dasha analysis',
    'mahadasha',
    'antardasha',
    'transit predictions',
    'gochar phal',
    'varshphal',
    'annual horoscope',
    
    // ==========================================
    // PRIORITY 10: Puja & Ritual Services
    // ==========================================
    'puja services',
    'puja online',
    'online puja booking',
    'puja path',
    'hindu puja',
    'vedic puja',
    'havan puja',
    'homam services',
    'yagna services',
    'graha shanti puja',
    'navgraha puja',
    'shani puja',
    'rahu ketu puja',
    'lakshmi puja',
    'ganesh puja',
    'satyanarayan puja',
    'rudrabhishek',
    'maha mrityunjaya jaap',
    'sunderkand path',
    'pandit for puja',
    'book pandit online',
    'ritual services',
    'religious services',
    
    // ==========================================
    // PRIORITY 11: Life Problem Solutions
    // ==========================================
    'love problem solution',
    'marriage problem solution',
    'career problem solution',
    'business problem solution',
    'health problem solution',
    'financial problem solution',
    'family problem solution',
    'relationship problem solution',
    'job problem solution',
    'education problem solution',
    'child problem solution',
    'divorce problem solution',
    'court case solution',
    'enemy problem solution',
    'vashikaran specialist',
    'love marriage specialist',
    'get ex back',
    'husband wife problem',
    
    // ==========================================
    // PRIORITY 12: Calendar & Panchanga Keywords
    // ==========================================
    'panchanga',
    'daily panchanga',
    'hindu panchang',
    'indian calendar',
    'hindu calendar 2025',
    'panchang 2025',
    'today panchang',
    'aaj ka panchang',
    'tithi today',
    'muhurat today',
    'shubh muhurat',
    'vivah muhurat',
    'griha pravesh muhurat',
    'date converter',
    'hindu date converter',
    
    // ==========================================
    // Brand Keywords
    // ==========================================
    'swastishanti',
    'swast shanti',
    'swasti bachan',
    'swastishanti astrology',
    
    // ==========================================
    // Trust & Success Keywords
    // ==========================================
    'trusted astrologer',
    'verified astrologer',
    'genuine astrologer',
    'accurate astrology',
    'accurate predictions',
    '98% success rate',
    'best rated astrologer',
    'top rated astrology',
    'highest success rate astrology',
  ],
};

// Focused keyword cluster used in metadata for stronger topical relevance.
export const coreAstrologyKeywords = [
  'vedic astrology',
  'vedic astrologer',
  'online vedic astrology consultation',
  'best astrologer in nepal',
  'best astrologer in india',
  'online astrologer',
  'jyotish consultation',
  'hindu astrology',
  'kundli reading',
  'janam kundli analysis',
  'kundali matching',
  'gun milan',
  'marriage astrology',
  'career astrology',
  'business astrology',
  'love problem solution astrology',
  'mangal dosh remedies',
  'kaal sarp dosh remedies',
  'shani sade sati remedies',
  'rahu ketu remedies',
  'graha shanti puja',
  'astrological remedies',
  'spiritual healing',
  'energy healing',
  'chakra healing',
  'negative energy removal',
  'gemstone astrology',
  'certified gemstones',
  'pukhraj stone',
  'neelam stone',
  'manik stone',
  'panna stone',
  'hindu panchang',
  'today panchang',
  'tithi today',
  'shubh muhurat',
  'date converter nepali to english',
  'date converter english to nepali',
  'nepali astrology',
  'indian astrology',
  'nri astrology consultation',
  'astrologer for usa clients',
  'astrologer for uk clients',
  'astrologer for dubai clients',
  'online puja booking',
  'hindu ritual services',
  'accurate astrology predictions',
  'trusted astrologer',
  'swastishanti',
  'swastishanti astrology',
];

export interface PageSEO {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  // Next.js OpenGraph only supports: 'website' | 'article' | 'profile'
  // Use 'website' as default, 'article' for blog posts, 'profile' for user pages
  type?: 'website' | 'article' | 'profile';
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  keywords?: string[];
}

/**
 * Generate JSON-LD structured data for Organization
 */
export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    alternateName: [
      siteConfig.alternativeName, 
      'Swasti Shanti', 
      'Best Astrology India Nepal',
      'Hindu Astrology Online',
      'Vedic Jyotish Services',
    ],
    url: siteConfig.url,
    logo: `${siteConfig.url}/logo.png`,
    description: siteConfig.description,
    foundingDate: '2010',
    slogan: 'India & Nepal\'s #1 Vedic Astrology Platform - Serving Hindu Community Worldwide',
    keywords: siteConfig.keywords.slice(0, 50).join(', '),
    sameAs: [
      'https://www.facebook.com/astroswastishanti/',
      'https://www.instagram.com/astro_swastishanti/',
      'https://youtube.com/channel/UCp3XRzKfPoDWgPGsOsHqQyA',
      'https://twitter.com/swastishanti',
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+9779851112728',
        contactType: 'Customer Service',
        email: 'info@swastishanti.com',
        availableLanguage: ['en', 'ne', 'hi', 'bn', 'ta', 'te', 'mr', 'gu'],
        areaServed: ['NP', 'IN', 'US', 'UK', 'AU', 'CA', 'AE', 'SG', 'MY', 'QA'],
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
          opens: '06:00',
          closes: '23:00',
        },
      },
      {
        '@type': 'ContactPoint',
        telephone: '+9779851112728',
        contactType: 'Sales',
        email: 'consultation@swastishanti.com',
        availableLanguage: ['en', 'ne', 'hi'],
      },
    ],
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'NP',
      addressLocality: 'Kathmandu',
      addressRegion: 'Bagmati Province',
      postalCode: '44600',
    },
    award: [
      'Best Vedic Astrology Platform 2024',
      'Highest Client Satisfaction Award',
      'Trusted Hindu Astrology Service',
      'Best Online Jyotish Service India Nepal',
    ],
    knowsAbout: [
      'Vedic Astrology',
      'Hindu Jyotish',
      'Jyotish Shastra',
      'Gemstone Recommendations',
      'Astrological Remedies',
      'Spiritual Healing',
      'Kundli Analysis',
      'Hindu Panchanga',
      'Hindu Calendar',
      'Puja Services',
      'Hindu Rituals',
      'Sanatan Dharma',
    ],
  };
}

/**
 * Generate JSON-LD structured data for LocalBusiness (better for local SEO)
 * Enhanced for India and Nepal markets
 */
export function generateLocalBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': `${siteConfig.url}#business`,
    name: 'Swastishanti - Best Vedic Astrology India & Nepal',
    alternateName: [
      siteConfig.name, 
      'Swasti Shanti Astrology',
      'Hindu Jyotish Online',
      'Indian Astrology Services',
    ],
    image: [
      siteConfig.ogImage,
      `${siteConfig.url}/logo.png`,
      `${siteConfig.url}/astrology-consultation.jpg`,
    ],
    url: siteConfig.url,
    description: 'India & Nepal\'s #1 Vedic Astrology Platform. Best Astrologers with 98% Success Rate. Expert Hindu Jyotish, Spiritual Healing, Gemstones, Remedies for all life problems. Serving Hindu community in India, Nepal, USA, UK, Australia, Canada, UAE & worldwide. 15,000+ satisfied clients.',
    telephone: '+9779851112728',
    email: 'info@swastishanti.com',
    priceRange: '$$',
    currenciesAccepted: 'NPR, INR, USD, GBP, AUD, CAD, AED',
    paymentAccepted: 'Cash, Credit Card, Online Payment, UPI, PayPal, eSewa, Khalti, Google Pay, PhonePe',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Kathmandu',
      addressLocality: 'Kathmandu',
      addressRegion: 'Bagmati Province',
      postalCode: '44600',
      addressCountry: 'NP',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 27.7172,
      longitude: 85.3240,
    },
    areaServed: [
      // Primary Markets
      {
        '@type': 'Country',
        name: 'Nepal',
      },
      {
        '@type': 'Country',
        name: 'India',
      },
      // Global Hindu Diaspora
      {
        '@type': 'Country',
        name: 'United States',
      },
      {
        '@type': 'Country',
        name: 'United Kingdom',
      },
      {
        '@type': 'Country',
        name: 'Australia',
      },
      {
        '@type': 'Country',
        name: 'Canada',
      },
      {
        '@type': 'Country',
        name: 'United Arab Emirates',
      },
      {
        '@type': 'Country',
        name: 'Singapore',
      },
      {
        '@type': 'Country',
        name: 'Malaysia',
      },
      {
        '@type': 'Country',
        name: 'Qatar',
      },
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Vedic Astrology & Spiritual Services',
      itemListElement: [
        {
          '@type': 'OfferCatalog',
          name: 'Astrology Consultation Services',
          itemListElement: [
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Kundli/Birth Chart Analysis',
                description: 'Comprehensive Vedic birth chart analysis by expert Hindu astrologers',
              },
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Marriage Compatibility (Kundali Milan)',
                description: 'Gun Milan and horoscope matching for marriage',
              },
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Career & Business Astrology',
                description: 'Vedic guidance for career growth and business success',
              },
            },
          ],
        },
        {
          '@type': 'OfferCatalog',
          name: 'Remedies & Healing Services',
          itemListElement: [
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Astrological Remedies',
                description: 'Effective Vedic remedies for all planetary doshas',
              },
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Spiritual Healing',
                description: 'Energy healing, chakra balancing, and spiritual wellness',
              },
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Service',
                name: 'Puja & Havan Services',
                description: 'Online and in-person Hindu puja, havan, and ritual services',
              },
            },
          ],
        },
        {
          '@type': 'OfferCatalog',
          name: 'Gemstone Services',
          itemListElement: [
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'Product',
                name: 'Certified Astrological Gemstones',
                description: 'Natural, certified Navratna gemstones for all rashis',
              },
            },
          ],
        },
      ],
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '06:00',
        closes: '23:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Saturday', 'Sunday'],
        opens: '07:00',
        closes: '22:00',
      },
    ],
    sameAs: [
      'https://www.facebook.com/astroswastishanti/',
      'https://www.instagram.com/astro_swastishanti/',
      'https://youtube.com/channel/UCp3XRzKfPoDWgPGsOsHqQyA',
    ],
  };
}

/**
 * Generate JSON-LD structured data for WebSite
 */
export function generateWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${siteConfig.url}#website`,
    name: 'Swastishanti - Best Vedic Astrology India & Nepal',
    alternateName: ['Swasti Shanti', 'Hindu Jyotish Online'],
    url: siteConfig.url,
    description: siteConfig.description,
    publisher: {
      '@id': `${siteConfig.url}#organization`,
    },
    inLanguage: ['en', 'hi', 'ne'],
    potentialAction: [
      {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteConfig.url}/search?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
      {
        '@type': 'ReadAction',
        target: `${siteConfig.url}/blog`,
      },
    ],
  };
}

/**
 * Generate JSON-LD structured data for a Service
 */
export function generateServiceSchema(serviceName: string, description: string, serviceType?: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: serviceName,
    description: description,
    serviceType: serviceType || 'Vedic Astrology Consultation',
    provider: {
      '@type': 'Organization',
      name: 'Swastishanti - Best Vedic Astrology India & Nepal',
      url: siteConfig.url,
    },
    areaServed: [
      {
        '@type': 'Country',
        name: 'India',
      },
      {
        '@type': 'Country',
        name: 'Nepal',
      },
      {
        '@type': 'Country',
        name: 'United States',
      },
      {
        '@type': 'Country',
        name: 'United Kingdom',
      },
      {
        '@type': 'Country',
        name: 'Australia',
      },
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Service Options',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Online Consultation (Video Call)',
          },
          availability: 'https://schema.org/InStock',
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Phone Consultation',
          },
          availability: 'https://schema.org/InStock',
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Chat Consultation',
          },
          availability: 'https://schema.org/InStock',
        },
      ],
    },
  };
}

/**
 * Generate Gemstone Product Schema for Store SEO
 */
// Extracts the two numbers out of a display string like "$60 - $600 per carat".
// Schema.org's Offer.price must be a plain number, not a range/currency-symbol string.
function parsePriceRange(price?: string): { minPrice: number; maxPrice: number } | null {
  if (!price) return null;
  const numbers = price.match(/[\d,]+(?:\.\d+)?/g)?.map((n) => parseFloat(n.replace(/,/g, '')));
  if (!numbers || numbers.length === 0) return null;
  return {
    minPrice: Math.min(...numbers),
    maxPrice: Math.max(...numbers),
  };
}

export function generateGemstoneSchema(gemstones: Array<{
  name: string;
  nepaliName: string;
  planet: string;
  benefits: string[];
  price?: string;
}>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Astrological Gemstones - Certified Navratna Gemstones India Nepal',
    description: 'Buy certified natural astrological gemstones (Navratna) for all zodiac signs. Expert gemstone recommendations by best Vedic astrologers. Serving India, Nepal & worldwide.',
    numberOfItems: gemstones.length,
    itemListElement: gemstones.map((gem, index) => {
      const range = parsePriceRange(gem.price);
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: `${gem.name} (${gem.nepaliName}) - Vedic Astrological Gemstone`,
          description: `Natural certified ${gem.name} for ${gem.planet}. Benefits: ${gem.benefits.join(', ')}. Best quality astrological gemstone with lab certification.`,
          category: 'Astrological Gemstones',
          brand: {
            '@type': 'Brand',
            name: 'Swastishanti Gemstones',
          },
          offers: {
            '@type': 'Offer',
            availability: 'https://schema.org/InStock',
            seller: {
              '@type': 'Organization',
              name: 'Swastishanti',
            },
            ...(range && {
              priceSpecification: {
                '@type': 'UnitPriceSpecification',
                minPrice: range.minPrice,
                maxPrice: range.maxPrice,
                priceCurrency: 'USD',
              },
            }),
          },
        },
      };
    }),
  };
}

/**
 * Generate Remedies Service Schema
 */
export function generateRemediesSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Astrological Remedies - Vedic Remedies for All Life Problems',
    alternateName: ['Graha Shanti Remedies', 'Hindu Jyotish Upay', 'Planetary Remedies'],
    description: 'Expert Vedic astrological remedies for all life problems. Effective Hindu remedies for marriage, career, health, wealth, and success. Graha Shanti, Mantra, Yantra, and Gemstone solutions by best astrologers in India & Nepal. Serving Hindu community worldwide.',
    serviceType: 'Astrological Remedies',
    provider: {
      '@type': 'Organization',
      name: 'Swastishanti - Best Vedic Astrology India & Nepal',
      url: siteConfig.url,
    },
    areaServed: [
      { '@type': 'Country', name: 'India' },
      { '@type': 'Country', name: 'Nepal' },
      { '@type': 'Country', name: 'United States' },
      { '@type': 'Country', name: 'United Kingdom' },
      { '@type': 'Country', name: 'Australia' },
      { '@type': 'Country', name: 'Canada' },
      { '@type': 'Country', name: 'United Arab Emirates' },
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Remedy Services',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Graha Shanti Puja',
            description: 'Powerful planetary remedies for Shani, Rahu, Ketu, Mangal doshas',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Mantra Remedies',
            description: 'Personalized Vedic mantra recommendations',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Yantra Remedies',
            description: 'Sacred yantras for protection and prosperity',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Gemstone Remedies',
            description: 'Expert gemstone recommendations based on Kundli',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Kaal Sarp Dosh Remedy',
            description: 'Effective solutions for Kaal Sarp Yoga',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Manglik Dosh Remedy',
            description: 'Solutions for Mangal Dosh and marriage problems',
          },
        },
      ],
    },
  };
}

/**
 * Generate Spiritual Healing Service Schema
 */
export function generateSpiritualHealingSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Spiritual Healing Services - Hindu Spiritual Healer India Nepal',
    alternateName: ['Energy Healing', 'Chakra Healing', 'Divine Healing'],
    description: 'Professional Hindu spiritual healing services. Energy healing, chakra balancing, aura cleansing, karmic healing, negative energy removal, and spiritual counseling by experienced healers. Serving India, Nepal, and Hindu community worldwide.',
    serviceType: 'Spiritual Healing',
    provider: {
      '@type': 'Organization',
      name: 'Swastishanti - Best Spiritual Healer India Nepal',
      url: siteConfig.url,
    },
    areaServed: [
      { '@type': 'Country', name: 'India' },
      { '@type': 'Country', name: 'Nepal' },
      { '@type': 'Country', name: 'United States' },
      { '@type': 'Country', name: 'United Kingdom' },
      { '@type': 'Country', name: 'Australia' },
      { '@type': 'Country', name: 'Canada' },
    ],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Healing Services',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Energy Healing',
            description: 'Restore balance and vitality through Vedic energy work',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Chakra Balancing',
            description: 'Align and balance your seven chakras using ancient Hindu methods',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Aura Cleansing',
            description: 'Remove negative energies and purify your aura',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Karmic Healing',
            description: 'Release karmic blocks and past life issues',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Negative Energy Removal',
            description: 'Protection from evil eye, black magic, and negative influences',
          },
        },
      ],
    },
  };
}

/**
 * Generate HowTo schema for Date Converter
 */
export function generateDateConverterHowToSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'How to Convert English Date to Nepali/Hindu Date',
    description: 'Step-by-step guide to convert dates between English (AD/Gregorian) and Hindu/Nepali (BS/Vikram Samvat) calendars.',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'Select Conversion Type',
        text: 'Choose whether you want to convert from Hindu/Nepali (BS/Vikram Samvat) to English (AD) or English (AD) to Hindu/Nepali (BS).',
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: 'Enter Date',
        text: 'Enter the year, month, and day of the date you want to convert.',
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: 'Click Convert',
        text: 'Click the Convert button to get the converted date instantly.',
      },
    ],
  };
}

/**
 * Generate BreadcrumbList schema for navigation
 */
export function generateBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

/**
 * Generate JSON-LD structured data for Article/Blog
 */
export function generateArticleSchema({
  title,
  description,
  image,
  url,
  publishedTime,
  modifiedTime,
  author = 'Swastishanti',
}: PageSEO) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    image: image || siteConfig.ogImage,
    url: url || siteConfig.url,
    datePublished: publishedTime,
    dateModified: modifiedTime || publishedTime,
    author: {
      '@type': 'Organization',
      name: author,
      url: siteConfig.url,
    },
    publisher: {
      '@type': 'Organization',
      name: siteConfig.name,
      logo: {
        '@type': 'ImageObject',
        url: `${siteConfig.url}/logo.png`,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url || siteConfig.url,
    },
    inLanguage: ['en', 'hi', 'ne'],
  };
}


/**
 * Generate FAQPage schema
 */
export function generateFAQSchema(faqs: Array<{ question: string; answer: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

/**
 * Generate default FAQ schema with common search queries - SEO optimized
 * Targeting: India, Nepal, Global Hindu Community
 */
export function generateDefaultFAQSchema() {
  return generateFAQSchema([
    // Best Astrology India/Nepal FAQs
    {
      question: 'Who is the best astrologer in India and Nepal?',
      answer: 'Swastishanti has India and Nepal\'s best Vedic astrologers with 98% client success rate. Our team of 25+ certified Jyotish experts provides accurate predictions and effective remedies. We are rated as the #1 Hindu astrology service serving India, Nepal, USA, UK, Australia, and worldwide. Trusted by 15,000+ satisfied clients. Book a consultation today for Kundli analysis, marriage compatibility, career guidance, and more.',
    },
    {
      question: 'What is the best online astrology service for Hindus?',
      answer: 'Swastishanti is the best online Vedic astrology platform for Hindus worldwide. We offer authentic Hindu Jyotish consultation, Kundli analysis, marriage compatibility (Gun Milan), career astrology, effective remedies, spiritual healing, and certified gemstone recommendations. Our services are available in English, Hindi, and Nepali. We serve the Hindu community in India, Nepal, USA, UK, Canada, Australia, UAE, Singapore, and 50+ countries.',
    },
    
    // Hindu Astrology & Culture FAQs
    {
      question: 'What is Hindu astrology (Jyotish)?',
      answer: 'Hindu astrology, also known as Jyotish Shastra or Vedic astrology, is the ancient Indian system of astronomy and astrology based on the Vedas. It uses the sidereal zodiac and considers the positions of nine planets (Navagraha) to predict life events and suggest remedies. Swastishanti provides authentic Hindu Jyotish services following Sanatan Dharma traditions, serving the Hindu community in India, Nepal, and worldwide.',
    },
    {
      question: 'What is a Kundli (Hindu Birth Chart)?',
      answer: 'Kundli (also called Janam Patri or Hindu birth chart) is a detailed astrological chart based on the exact time, date, and place of birth. It shows the positions of planets in 12 houses and reveals insights about career, marriage, health, wealth, and life path. Swastishanti expert astrologers provide comprehensive Kundli analysis and personalized predictions. Get your Kundli analyzed today!',
    },
    
    // Astrological Remedies FAQs
    {
      question: 'What are Vedic astrological remedies?',
      answer: 'Vedic astrological remedies (Jyotish Upay) are traditional Hindu solutions to neutralize negative planetary effects. These include Graha Shanti Puja, Mantra chanting, Yantra worship, Gemstone wearing, Havan/Homam, fasting (Vrat), charity (Daan), and specific rituals. Swastishanti astrologers provide personalized remedies for Shani Sade Sati, Mangal Dosh, Kaal Sarp Dosh, Rahu-Ketu problems, and all life challenges.',
    },
    {
      question: 'How to remove Mangal Dosh for marriage?',
      answer: 'Mangal Dosh (Manglik Dosha) can be remedied through: Mangal Shanti Puja, Kumbh Vivah ritual, wearing Red Coral (Moonga) gemstone, chanting Mangal Mantra, fasting on Tuesdays, and Hanuman Puja. Our expert Vedic astrologers at Swastishanti analyze your Kundli to determine the severity and recommend the most effective remedies. Many clients have successfully married after our Manglik remedies.',
    },
    {
      question: 'What are effective Shani Sade Sati remedies?',
      answer: 'Effective Shani Sade Sati remedies include: reciting Shani Mantra (Om Sham Shanicharaya Namah), wearing Blue Sapphire (Neelam) after consultation, performing Shani Shanti Puja, donating black items on Saturdays, fasting on Saturdays, lighting til (sesame) oil lamp, and visiting Shani temples. Swastishanti provides complete Shani Sade Sati guidance with 98% success rate.',
    },
    
    // Spiritual Healing FAQs
    {
      question: 'What is spiritual healing in Hindu tradition?',
      answer: 'Hindu spiritual healing combines Vedic wisdom with energy work to address mental, emotional, and spiritual well-being. It includes Chakra balancing, Aura cleansing, Kundalini awakening, Prana healing, meditation, and mantra therapy. Swastishanti offers professional spiritual healing services based on Sanatan Dharma, serving the Hindu community in India, Nepal, and globally.',
    },
    {
      question: 'How to remove negative energy and evil eye (Nazar)?',
      answer: 'To remove negative energy and Nazar (evil eye): perform Nazar Utarna ritual, use camphor and salt cleansing, wear protective yantras, chant Hanuman Chalisa, light incense, use black thread or evil eye beads, and get spiritual healing. Swastishanti healers specialize in negative energy removal, black magic protection, and spiritual cleansing for Hindu families worldwide.',
    },
    
    // Gemstone FAQs
    {
      question: 'Which gemstone should I wear according to Hindu astrology?',
      answer: 'The right gemstone depends on your Kundli, Moon sign (Rashi), and planetary positions. The Navratna (9 gems) are: Ruby (Manik) for Sun, Pearl (Moti) for Moon, Red Coral (Moonga) for Mars, Emerald (Panna) for Mercury, Yellow Sapphire (Pukhraj) for Jupiter, Diamond (Heera) for Venus, Blue Sapphire (Neelam) for Saturn, Hessonite (Gomed) for Rahu, and Cat\'s Eye (Lahsuniya) for Ketu. Consult Swastishanti astrologers for personalized recommendations.',
    },
    {
      question: 'Where to buy certified astrological gemstones in India?',
      answer: 'Swastishanti offers certified natural astrological gemstones with lab certification and authenticity guarantee. We provide: Kundli-based gemstone recommendations, natural untreated stones, proper energization (Pran Pratishtha), worldwide shipping to India, Nepal, USA, UK, Australia. Our gemstones come with lifetime exchange policy. Contact us for genuine Navratna gemstones.',
    },
    
    // Puja & Services FAQs
    {
      question: 'Can I book Hindu puja online?',
      answer: 'Yes! Swastishanti offers online Hindu puja booking for devotees in India, Nepal, and worldwide. We provide: Graha Shanti Puja, Satyanarayan Puja, Rudrabhishek, Navgraha Puja, Lakshmi Puja, Ganesh Puja, Maha Mrityunjaya Jaap, Sunderkand Path, and all Hindu rituals. Our experienced Pandits perform authentic Vedic pujas with live streaming option.',
    },
    {
      question: 'What services does Swastishanti offer for NRIs?',
      answer: 'Swastishanti provides comprehensive astrology services for NRIs (Non-Resident Indians) and overseas Hindus: Online video consultation, Phone consultation, WhatsApp support, Kundli analysis, Marriage matching, Remedies consultation, Online puja services, Gemstone delivery worldwide, and Spiritual healing sessions. We serve Hindu families in USA, UK, Canada, Australia, UAE, Singapore, and 50+ countries.',
    },
    
    // General FAQs
    {
      question: 'What is Swastishanti?',
      answer: 'Swastishanti is India and Nepal\'s #1 Vedic astrology platform with 98% client success rate. We offer expert Hindu Jyotish consultation, Kundli analysis, marriage compatibility, effective astrological remedies, spiritual healing, certified gemstones, Hindu Panchang, and puja services. Trusted by 15,000+ clients across India, Nepal, USA, UK, Australia, Canada, UAE, and 50+ countries. Our 25+ expert astrologers follow authentic Sanatan Dharma traditions.',
    },
    {
      question: 'How accurate are Swastishanti astrology predictions?',
      answer: 'Swastishanti maintains 98% client success rate, the highest in the industry. Our accuracy comes from: expert Vedic astrologers with 15+ years experience, authentic Jyotish Shastra methods, comprehensive Kundli analysis, personalized predictions, and proven remedies. We have helped 15,000+ clients solve marriage, career, health, and financial problems. Read our verified client testimonials.',
    },
  ]);
}

